// extracted by mini-css-extract-plugin
export default {"recos":"p3-z","productCardOverride":"q3-z","rowHasBadge":"r3-z"};